import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { openUpgradeSheet } from "@/components/UpgradeSheet";
import { Video, MessageCircle } from "lucide-react";

export function UsagePill() {
  const { data } = useQuery({ queryKey: ["usage"], queryFn: async () => (await api.get("/usage")).data, refetchInterval: 30000 });
  if (!data || data.premium) return null;
  const blocked = data.locked || data.calls_blocked;
  return (
    <button data-testid="usage-pill" onClick={() => blocked && openUpgradeSheet({ reason: "calls", usage: data })}
      title={data.trial_active ? `Free trial — ${data.trial_days_left} days left` : "Daily free allowance"}
      className={`h-8 px-3 rounded-full text-xs font-bold flex items-center gap-2 border transition-colors ${blocked ? "border-pink-400/60 text-pink-200 bg-pink-500/10" : "border-amber-400/30 text-amber-200 bg-amber-400/5"}`}>
      <span className="flex items-center gap-1" data-testid="usage-calls"><Video className="h-3.5 w-3.5" />{data.calls_left}/{data.calls_limit}</span>
      {data.messages_limit != null && <span className="flex items-center gap-1" data-testid="usage-messages"><MessageCircle className="h-3.5 w-3.5" />{data.messages_left}</span>}
      {data.trial_active && <span data-testid="usage-trial" className="hidden sm:inline text-[10px] font-semibold text-emerald-200/70">Trial · {data.trial_days_left}d</span>}
    </button>
  );
}
